module.exports = ".payment_receipt_lhs{height: 90vh; overflow-y: auto;}\r\n.payment_receipt_rhs{height: 90vh; overflow-y: auto;}\r\ntd receipt_left_side{\r\n    background-color: #ffeee0;\r\n    }"


//////////////////
// WEBPACK FOOTER
// ./src/app/dash-board/paymernt-receipt-container/payment-receipt-container-debitcard/payment-receipt-container-debitcard.component.css
// module id = ./src/app/dash-board/paymernt-receipt-container/payment-receipt-container-debitcard/payment-receipt-container-debitcard.component.css
// module chunks = main